import React from 'react';
import { Link } from 'react-router-dom';
import './Services.css';
import SEO from '../SEO';
import {
    FaHeartbeat,
    FaBone,
    FaBaby,
    FaFemale,
    FaUserMd,
    FaCog,
    FaBrain,
    FaUtensils,
    FaLungs,
    FaEye,
    FaHandSparkles,
    FaVial,
    FaPills,
    FaAmbulance,
    FaRunning,
    FaTooth,
    FaMicroscope
} from 'react-icons/fa';

function Services() {
    const services = [
        {
            name: 'Cardiology',
            slug: 'cardiology',
            icon: <FaHeartbeat />,
            description: 'Comprehensive heart care and cardiovascular treatments.',
            shortDesc: 'Advanced cardiac care with state-of-the-art technology'
        },
        {
            name: 'Orthopaedics',
            slug: 'orthopaedics',
            icon: <FaBone />,
            description: 'Expert care for bones, joints, and musculoskeletal issues.',
            shortDesc: 'Specialized treatment for bone and joint disorders'
        },
        {
            name: 'Pediatrics and Neonatal Care',
            slug: 'pediatrics-neonatal-care',
            icon: <FaBaby />,
            description: 'Specialized care for children and newborns.',
            shortDesc: 'Comprehensive healthcare for infants and children'
        },
        {
            name: 'Obstetrics and Gynaecology',
            slug: 'obstetrics-gynaecology',
            icon: <FaFemale />,
            description: 'Women\'s health, pregnancy, and gynecological services.',
            shortDesc: 'Complete women\'s health and maternity care'
        },
        {
            name: 'General Surgery',
            slug: 'general-surgery',
            icon: <FaUserMd />,
            description: 'Advanced surgical procedures for various conditions.',
            shortDesc: 'Expert surgical interventions and procedures'
        },
        {
            name: 'General Services',
            slug: 'general-services',
            icon: <FaCog />,
            description: 'Comprehensive general medical services.',
            shortDesc: 'Primary healthcare and wellness services'
        },
        {
            name: 'Neurology',
            slug: 'neurology',
            icon: <FaBrain />,
            description: 'Diagnosis and treatment of neurological disorders.',
            shortDesc: 'Advanced neurological care and treatment'
        },
        {
            name: 'Gastroenterology',
            slug: 'gastroenterology',
            icon: <FaUtensils />,
            description: 'Care for digestive system and related conditions.',
            shortDesc: 'Digestive health and gastrointestinal care'
        },
        {
            name: 'Pulmonology',
            slug: 'pulmonology',
            icon: <FaLungs />,
            description: 'Respiratory health and lung disease management.',
            shortDesc: 'Comprehensive respiratory and lung care'
        },
        {
            name: 'ENT (Ear, Nose, Throat)',
            slug: 'ent',
            icon: <FaEye />,
            description: 'Specialized care for ear, nose, and throat issues.',
            shortDesc: 'Expert ENT care and treatment'
        },
        {
            name: 'Dermatology',
            slug: 'dermatology',
            icon: <FaHandSparkles />,
            description: 'Skin, hair, and cosmetic dermatological services.',
            shortDesc: 'Advanced skin care and dermatological services'
        },
        {
            name: 'Urology and Nephrology',
            slug: 'urology-nephrology',
            icon: <FaVial />,
            description: 'Care for urinary and kidney-related conditions.',
            shortDesc: 'Specialized urological and kidney care'
        },
        {
            name: '24/7 Clinical Laboratory',
            slug: 'clinical-laboratory',
            icon: <FaMicroscope />,
            description: 'Round-the-clock diagnostic testing services.',
            shortDesc: '24/7 diagnostic testing and laboratory services'
        },
        {
            name: '24/7 Pharmacy',
            slug: 'pharmacy',
            icon: <FaPills />,
            description: 'Always available pharmaceutical services.',
            shortDesc: 'Round-the-clock pharmacy services'
        },
        {
            name: 'Emergency and Trauma Care',
            slug: 'emergency-trauma-care',
            icon: <FaAmbulance />,
            description: 'Immediate care for emergencies and trauma.',
            shortDesc: '24/7 emergency medical services'
        },
        {
            name: 'Physiotherapy and Rehabilitation',
            slug: 'physiotherapy-rehabilitation',
            icon: <FaRunning />,
            description: 'Rehabilitation and physical therapy services.',
            shortDesc: 'Expert physiotherapy and rehabilitation'
        },
        {
            name: 'Dentistry',
            slug: 'dentistry',
            icon: <FaTooth />,
            description: 'Comprehensive dental care and treatments.',
            shortDesc: 'Complete dental care and oral health'
        },
        {
            name: 'Oncology',
            slug: 'oncology',
            icon: <FaUserMd />,
            description: 'Cancer diagnosis, treatment, and support.',
            shortDesc: 'Comprehensive cancer care and treatment'
        }
    ];

    return (
        <React.Fragment>
            <SEO
                title="Medical Services | JDS Hospitals Visakhapatnam"
                description="JDS Hospitals offers 18+ speciality services including Cardiology, Neurology, Orthopaedics, Paediatrics, Gynaecology, Cancer Care, Emergency, Dermatology and more in Visakhapatnam."
                keywords="JDS Hospitals services, cardiology Vizag, neurology Visakhapatnam, orthopaedics Vizag, gynaecology hospital, cancer care Visakhapatnam, emergency care Vizag, dermatology Visakhapatnam"
                path="/Services"
            />
            <section className="services-section">
                <div className="container">
                    <div className="services-header">
                        <h1 className="services-title">Our Medical Services</h1>
                        <p className="services-subtitle">Experience world-class healthcare with our comprehensive range of specialized medical services. Each department is equipped with cutting-edge technology and staffed by expert medical professionals.</p>
                    </div>
                    <div className="services-grid">
                        {services.map((service, index) => (
                            <Link key={index} to={`/services/${service.slug}`} className="service-card-link">
                                <div className="service-card">
                                    <div className="service-icon">
                                        {service.icon}
                                    </div>
                                    <h3 className="service-name">{service.name}</h3>
                                    <p className="service-description">{service.description}</p>
                                    <p className="service-short-desc">{service.shortDesc}</p>
                                    <div className="learn-more">
                                        <span>Learn More</span>
                                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M7 17L17 7M17 7H7M17 7V17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </div>
                                </div>
                            </Link>
                        ))}
                    </div>
                </div>
            </section>
        </React.Fragment>
    );
}

export default Services;
